import { usePermissions } from '@customerio/hydra-permissions/react';

export function useAssetPermissions() {
  const { hasPermission } = usePermissions();
  const canCreate = hasPermission('journeys/assets/create');
  const canEdit = hasPermission('journeys/assets/edit');
  const canDelete = hasPermission('journeys/assets/delete');

  return { canCreate, canEdit, canDelete };
}
